
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cupons",
      function () {
        return require("private-next-pages/cupons/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cupons"])
      });
    }
  